import "./AchievementHero.css";
import GalleryBannerCanvas from "./GalleryBannerCanvas";

import {
  FaArrowRight,
  FaAward,
  FaCalendarAlt,
  FaImages,
  FaUsers,
} from "react-icons/fa";

function AchievementHero() {
  function navigateToGallery(showEvents = false) {
    const target = document.getElementById(showEvents ? "gallery-events" : "gallery-collection");
    if (!target) return;
    target.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      block: "start",
    });
    const focusTarget = showEvents ? document.getElementById("gallery-event-select") : target;
    focusTarget?.focus({ preventScroll: true });
  }

  return (
    <section className="achievement-hero">
      <GalleryBannerCanvas />
      <div className="achievement-hero-left">
        <span className="achievement-tag">Campus Life & Achievements</span>

        <h1>
          A curated view of
          <span> student excellence</span>
        </h1>

        <p>
          Explore campus events, student achievements, facilities, and everyday
          moments through a cleaner gallery experience designed for quick
          browsing.
        </p>

        <div className="achievement-buttons">
          <button className="achievement-primary-btn" type="button" onClick={() => navigateToGallery()}>
            Explore Gallery
            <FaArrowRight />
          </button>

          <button className="achievement-secondary-btn" type="button" onClick={() => navigateToGallery(true)}>
            View Events
          </button>
        </div>
      </div>

      <div className="achievement-hero-right" aria-label="Gallery summary">
        <div className="achievement-stat-card">
          <FaImages />
          <h2>1200+</h2>
          <p>Gallery Photos</p>
        </div>

        <div className="achievement-stat-card">
          <FaCalendarAlt />
          <h2>150+</h2>
          <p>College Events</p>
        </div>

        <div className="achievement-stat-card">
          <FaAward />
          <h2>85+</h2>
          <p>Achievements</p>
        </div>

        <div className="achievement-stat-card">
          <FaUsers />
          <h2>4500+</h2>
          <p>Students</p>
        </div>
      </div>
    </section>
  );
}

export default AchievementHero;
